import { render, staticRenderFns } from "./MaterialsInformation.vue?vue&type=template&id=1fa67c51&scoped=true&"
import script from "./MaterialsInformation.vue?vue&type=script&lang=js&"
export * from "./MaterialsInformation.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsInformation.vue?vue&type=style&index=0&id=1fa67c51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa67c51",
  null
  
)

export default component.exports